import gql from 'graphql-tag';
import className from 'classnames/bind';
import { RichTextFragment } from '@graphqlTypes';
import { Container } from '@components';

import styles from './RichText.module.scss';
const cx = className.bind(styles);

export default function RichText({ richTextContent }: RichTextFragment) {
  return (
    <section className={cx(["rich-text"])}>
      <Container>
        <div
          className={cx("rich-text__content")}
          dangerouslySetInnerHTML={{ __html: richTextContent || '' }}
        />
      </Container>
    </section>
  )
}

RichText.fragments = {
  entry: gql`
    fragment RichText on FlexiblePageContentContentRichTextLayout {
      richTextContent
    }
  `,
};